import { IconBetDrawerEmpty } from "app/components/Icon/Icon";
import { ReportTypes } from "app/utils/const";
import isPublicView from "app/utils/publicViewUtils";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const OpenBetsEmptyList: React.FC = () => {
  return (
    <div className="bet-drawer__empty-list no-open-bets">
      <IconBetDrawerEmpty />
      <span className="bet-drawer__empty-list__text">
        <FormattedMessage tagName="span" id="bets-slip-open-bets-none" />
      </span>
      <Link
        className="manage-bets-layout__collapse-button"
        to={{
          pathname: "/reports/statement/",
          state: {
            tab: ReportTypes.SETTLED,
          },
        }}
      >
        {isPublicView() ? (
          ""
        ) : (
          <FormattedMessage
            tagName="span"
            id="bets-slip-view-all-settled-bets"
          />
        )}
      </Link>
    </div>
  );
};

export default React.memo(OpenBetsEmptyList);
